module.exports = __webpack_public_path__ + "img/four.0f5b163e.png";